import { render } from "./paymentPending.vue?vue&type=template&id=e586756c&lang=true"
import script from "./paymentPending.vue?vue&type=script&lang=js"
export * from "./paymentPending.vue?vue&type=script&lang=js"

import "./paymentPending.vue?vue&type=style&index=0&id=e586756c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__